import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { delReceive, receiveList, gmWelfareWhiteDel } from "@/api/gmtool/packageCode";
import addassociationManagement from "./components/addassociationManagement";
import { gmTool } from "@/mixins/index";
export default {
  name: "associationManagement",
  components: {
    addassociationManagement: addassociationManagement
  },
  mixins: [gmTool],
  data: function data() {
    return {
      paramsData: {
        page: 1,
        user_id: '',
        refresh_interval: ''
      }
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.getList();

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    updateList: function updateList() {
      this.getList(this.paramsData.page);
    },
    getList: function getList() {
      var _this2 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.reqLoading = true;
      this.paramsData.page = e;
      receiveList(this.paramsData).then(function (res) {
        if (res.status == 200) {
          if (!res.data.data.length && _this2.paramsData.page > 1) {
            _this2.getList(_this2.paramsData.page - 1);
          } else {
            _this2.tableData = res.data.data;
            _this2.total = res.data.total;
          }
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this3 = this;

      this.sels = [];
      val.forEach(function (e) {
        if (_this3.tableData.findIndex(function (i) {
          return i.id == e.id;
        }) > -1) {
          _this3.sels.push(e.id);
        }
      });
      this.selsString = this.sels.toString();
    },
    // 删除配置
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      this.$confirm(this.$t('confirmDelete'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                delReceive(_objectSpread({
                  id: id
                }, _this4.paramsData)).then(function (res) {
                  if (res.status == 200) {
                    _this4.getList(_this4.paramsData.page);

                    _this4.$message({
                      type: "success",
                      message: _this4.$t('unlinkSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};